import IntegerField from './IntegerField';

export default IntegerField;
